// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1BhkQ","subheader":"ReorderModal_subheader__3Oh4J","listWrap":"ReorderModal_listWrap__2VYnZ"};